import React from 'react'
import './Main.css'

const Main = () => {

  return (
    <section className='Main'>
      <h1 className='Main-text'>
        <span>External</span>
        <span className='Main-text__main'>design department</span>
        <span>For your IT-company</span>
      </h1>
    </section>
  )
}

export default Main